import moment from "moment";

import { DateTableCellProps } from "./ItemsTable.types";

const DateTableCell = ({
  date,
  withTime = true,
  noDatePlaceholder = "-"
}: DateTableCellProps) => {
  if (!date) return <>{noDatePlaceholder}</>;

  return (
    <pre>
      {`${moment(date).format("DD/MM/YYYY")}`}
      {withTime && `\n${moment(date).format("HH:mm")}`}
    </pre>
  );
};

export default DateTableCell;
